import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd-mobile/dist/antd-mobile.css';  
import './css/xuui.css';
import './css/style.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

